import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from './utils/cn';

interface ViewIndicatorProps {
  label: string;
  icon: LucideIcon;
  className?: string;
}

export const ViewIndicator: React.FC<ViewIndicatorProps> = ({ label, icon: Icon, className }) => {
  return (
    <div className={cn("flex items-center gap-1.5 px-2 py-1 rounded-md bg-bg-tertiary/50 border border-border-default", className)}>
      <Icon className="size-3.5 text-text-supporting" />
      <span className="text-[11px] font-semibold text-text-supporting tracking-wider uppercase">
        {label}
      </span>
    </div>
  );
};
